module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/305.aef5b128.png";